/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import VacationStatus from "./VacationStatus";
import ChangeHistory from "./ChangeHistory";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

const VacationAssignStatus = (props) => {
  const history = useHistory();
  const { permissions } = useSelector((store) => ({ permissions: store.Profile.permissions }));
  const [activeTab, setActiveTab] = useState('vacation-info');
  const [targetPermission, setTargetPermission] = useState(null)

  const _setActiveTab = (value) => {
    history.push(`/vacation/assign-status?tab=${value}`);
  };

  const tabList = [
    {
      label: "휴가 정보",
      action: _setActiveTab,
      value: 'vacation-info'
    },
    {
      label: "변경 이력",
      action: _setActiveTab,
      value: 'change-history'
    },
  ];

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'ADDED_VACATION_HISTORY')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "ADDED_VACATION_HISTORY")
      }
    }
  }, [permissions])

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  return (
    !isEmpty(targetPermission) && (
      <>
        {activeTab === 'vacation-info' &&
          <VacationStatus
            tabList={tabList}
            activeTab={activeTab}
          />}
        {activeTab === 'change-history' &&
          <ChangeHistory
            tabList={tabList}
            activeTab={activeTab}
          />}
      </>
    )
  );
};

export default VacationAssignStatus;
